import Layout from '@/components/Layout'
import LayoutTop from '@/components/Layout/Top'

const routes = [
    // 数据看板
    {
        path: '/home',
        name: 'Home',
        redirect: '/home',
        component: Layout,
        meta: {
            title: '首页'
        },
        children: [
            {
                path: '/home',
                component: () => import(/*webpackChunkName: "home"*/ '@/views/dashboard/index'),
                meta: {
                    title: ''
                }
            }
        ]
    },
    // 基础服务
    {
        path: '/basic-services',
        name: 'basic-services',
        redirect: '/basic-services',
        component: Layout,
        meta: {
            title: '基础服务'
        },
        children: [
            {
                path: '/basic-services/cooperation',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/basic-services/cooperation',
                        name: 'Cooperation',
                        component: () => import(/*webpackChunkName: "cooperation"*/ '@/views/basic-services/cooperation/index'),
                        meta: {
                            title: '合作管理'
                        }
                    },
                    {
                        path: '/basic-services/cooperation/detail',
                        name: 'cooperationDetail',
                        component: () => import(/*webpackChunkName: "cooperation"*/ '@/views/basic-services/cooperation/detail'),
                        meta: {
                            title: '合作管理-详情'
                        }
                    },
                    {
                        path: '/basic-services/branch-management',
                        name: 'BranchManagement',
                        component: () => import(/*webpackChunkName: "branch-management"*/ '@/views/basic-services/branch-management/index'),
                        meta: {
                            title: '分公司管理'
                        }
                    },
                    {
                        path: '/basic-services/shop-management',
                        name: 'shopManagement',
                        component: () => import('@/components/EmptyTemplate'),
                        children: [
                            {
                                path: '/basic-services/shop-management',
                                name: 'shopManagementList',
                                component: () => import(/*webpackChunkName: "shop-management"*/ '@/views/basic-services/shop-management/index'),
                                meta: {
                                    title: '店铺管理'
                                }
                            },
                            {
                                path: '/basic-services/shop-management/edit',
                                name: 'shopManagementEdit',
                                component: () => import(/*webpackChunkName: "shop-management-edit"*/ '@/views/basic-services/shop-management/Edit'),
                                meta: {
                                    title: '店铺管理 '
                                }
                            },
                            {
                                path: '/basic-services/shop-management/detail',
                                name: 'shopManagementDetail',
                                component: () => import(/*webpackChunkName: "shop-management-detail"*/ '@/views/basic-services/shop-management/Detail'),
                                meta: {
                                    title: '店铺管理-详情'
                                }
                            }
                        ]
                    },
                    {
                        path: '/basic-services/commodity-data',
                        name: 'CommodityData',
                        component: () => import('@/components/EmptyTemplate'),
                        children: [
                            {
                                path: '/basic-services/commodity-data',
                                name: 'CommodityDataList',
                                component: () => import(/*webpackChunkName: "commodity-data"*/ '@/views/basic-services/commodity-data/index'),
                                meta: {
                                    title: '商品提报'
                                }
                            }
                            // {
                            //     path: '/basic-services/commodity-data/edit',
                            //     name: 'CommodityDataEdit',
                            //     component: () => import('@/views/basic-services/commodity-data/edit'),
                            //     meta: {
                            //         title: '商品提报-编辑'
                            //     }
                            // },
                            // {
                            //     path: '/basic-services/commodity-data/detail',
                            //     name: 'CommodityDataDetail',
                            //     component: () => import('@/views/basic-services/commodity-data/detail'),
                            //     meta: { title: '商品提报-详情' }
                            // }
                        ]
                    },
                    {
                        path: '/basic-services/commodity-list',
                        name: 'Commodity',
                        component: () => import('@/components/EmptyTemplate'),
                        children: [
                            {
                                path: '/basic-services/commodity-list',
                                name: 'CommodityList',
                                component: () => import(/*webpackChunkName: "CommodityList"*/ '@/views/basic-services/commodity-list/index'),
                                meta: {
                                    title: '商品列表'
                                }
                            }
                            // {
                            //     path: '/basic-services/commodity-list/edit',
                            //     name: 'CommodityListEdit',
                            //     component: () => import('@/views/basic-services/commodity-list/edit'),
                            //     meta: { title: '商品列表-编辑' }
                            // },
                            // {
                            //     path: '/basic-services/commodity-list/detail',
                            //     name: 'CommodityListDetail',
                            //     component: () => import('@/views/basic-services/commodity-list/detail'),
                            //     meta: { title: '商品列表-详情' }
                            // }
                        ]
                    },
                    {
                        path: '/basic-services/product-common',
                        name: 'ProductCommon',
                        component: () => import(/*webpackChunkName: "ProductCommon"*/ '@/views/basic-services/components/CommodityFormTpl'),
                        meta: {
                            title: '商品主数据'
                        }
                    },
                    {
                        path: '/basic-services/store-commodity',
                        name: 'StoreCommodity',
                        component: () => import(/*webpackChunkName: "StoreCommodity"*/ '@/views/basic-services/store-commodity/index'),
                        meta: {
                            title: '店铺商品管理'
                        }
                    },
                    {
                        path: '/basic-services/batch',
                        name: 'Batch',
                        component: () => import(/*webpackChunkName: "batch"*/ '@/views/basic-services/batch/index'),
                        meta: {
                            title: '批量管理'
                        }
                    },
                    // {
                    //     path: '/basic-services/evaluate',
                    //     name: 'Evaluate',
                    //     component: () => import('@/views/basic-services/evaluate/index'),
                    //     meta: {
                    //         title: '评价管理'
                    //     }
                    // },
                    {
                        path: '/basic-services/freight',
                        name: 'Freight',
                        component: () => import(/*webpackChunkName: "Freight"*/ '@/views/basic-services/freight/index'),
                        meta: {
                            title: '运费设置'
                        }
                    },
                    {
                        path: '/basic-services/urban-freight',
                        name: 'UrbanFreight',
                        component: () => import(/*webpackChunkName: "UrbanFreight"*/ '@/views/basic-services/urban-freight/index'),
                        meta: {
                            title: '城市运费'
                        }
                    },
                    {
                        path: '/basic-services/fence-binding',
                        component: () => import('@/components/EmptyTemplate'),
                        children: [
                            {
                                path: '/basic-services/fence-binding',
                                name: 'FenceBindingList',
                                component: () => import(/*webpackChunkName: "FenceBindingList"*/ '@/views/basic-services/fence-binding/index'),
                                meta: {
                                    title: '围栏绑定'
                                }
                            },
                            {
                                path: '/basic-services/fence-binding/edit',
                                name: 'FenceBindingEdit',
                                component: () => import(/*webpackChunkName: "FenceBindingEdit"*/ '@/views/basic-services/fence-binding/Edit'),
                                meta: {
                                    title: '围栏绑定-装修'
                                }
                            }
                        ]
                    },
                    {
                        path: '/basic-services/fence-view',
                        name: 'FenceView',
                        component: () => import(/*webpackChunkName: "FenceView"*/ '@/views/basic-services/fence-view/index'),
                        meta: {
                            title: '围栏查看'
                        }
                    },
                    {
                        path: '/basic-services/message-configure',
                        name: 'MessageView',
                        component: () => import(/*webpackChunkName: "FenceView"*/ '@/views/basic-services/message-configure/index'),
                        meta: {
                            title: '短信接收配置'
                        }
                    },
                    {
                        path: '/basic-services/global-setting',
                        name: 'globalSettingView',
                        component: () => import(/*webpackChunkName: "FenceView"*/ '@/views/basic-services/globalSetting/index'),
                        meta: {
                            title: '默认配置管理'
                        }
                    },
                    {
                        path: '/basic-services/bank',
                        name: 'bankView',
                        component: () => import('@/components/EmptyTemplate'),
                        children: [
                            {
                                path: '/basic-services/bank',
                                name: 'bankList',
                                component: () => import(/*webpackChunkName: "FenceView"*/ '@/views/basic-services/bank/index'),
                                meta: {
                                    title: '银行信息'
                                }
                            },
                            {
                                path: '/basic-services/bank/edit',
                                name: 'bankEdit',
                                component: () => import(/*webpackChunkName: "bank"*/ '@/views/basic-services/bank/Edit'),
                                meta: {
                                    title: '银行信息-编辑'
                                }
                            },
                            {
                                path: '/basic-services/bank/detail',
                                name: 'bankDetail',
                                component: () => import(/*webpackChunkName: "bank"*/ '@/views/basic-services/bank/Detail'),
                                meta: {
                                    title: '银行信息-详情'
                                }
                            }
                        ]
                    },
                    {
                        path: '/basic-services/commodity-attribute',
                        name: 'commodityAttribute',
                        component: () => import(/*webpackChunkName: "commodityAttribute"*/ '@/views/basic-services/commodity-attribute/index'),
                        meta: {
                            title: '自定义商品属性'
                        }
                    },
                ]
            }
        ]
    },
    // 店铺装修
    {
        path: '/shop',
        name: 'Shop',
        redirect: '/shop',
        component: Layout,
        meta: {
            title: '店铺装修'
        },
        children: [
            {
                path: '/shop/list',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/shop/list',
                        component: () => import('@/components/EmptyTemplate'),
                        children: [
                            {
                                path: '/shop/list',
                                name: 'ShopList',
                                component: () => import(/*webpackChunkName: "ShopList"*/ '@/views/shop/list/index'),
                                meta: {
                                    title: '店铺首页'
                                }
                            }
                            // {
                            //     path: '/shop/edit',
                            //     name: 'ShopListEdit',
                            //     component: () => import('@/views/shop/list/edit'),
                            //     meta: {
                            //         title: '店铺装修'
                            //     }
                            // }
                        ]
                    },
                    {
                        path: '/shop/classification',
                        name: 'StoreClassification',
                        component: () => import(/*webpackChunkName: "StoreClassification"*/ '@/views/shop/classification/index'),
                        meta: {
                            title: '店铺分类(按分类)'
                        }
                    },
                    {
                        path: '/shop/goodscation',
                        name: 'GoodsShopCation',
                        component: () => import(/*webpackChunkName: "GoodsShopCation"*/ '@/views/shop/goodscation/index'),
                        meta: {
                            title: '店铺分类(按商品)'
                        }
                    },

                    {
                        path: '/shop/material-library',
                        name: 'MaterialLibrary',
                        component: () => import(/*webpackChunkName: "MaterialLibrary"*/ '@/views/shop/material-library/index'),
                        meta: {
                            title: '素材库'
                        }
                    },
                    {
                        path: '/shop/top-search-terms',
                        name: 'TopSearchTerms',
                        component: () => import(/*webpackChunkName: "TopSearchTerms"*/ '@/views/shop/top-search-terms/index'),
                        meta: {
                            title: '热门搜索词管理'
                        }
                    },
                    {
                        path: '/shop/copywriting',
                        name: 'Copywriting',
                        component: () => import(/*webpackChunkName: "Copywriting"*/ '@/views/shop/copywriting/index'),
                        meta: {
                            title: '搜索框文案管理'
                        }
                    },
                    {
                        path: '/shop/cityShippingRule',
                        name: 'CityShippingRule',
                        component: () => import(/*webpackChunkName: "Copywriting"*/ '@/views/shop/cityShippingRule/index'),
                        meta: {
                            title: '运费规则管理'
                        }
                    }
                ]
            }
        ]
    },
    // 店铺编辑单独的路由 LayoutTop
    {
        path: '/shop',
        name: 'Shops',
        component: LayoutTop,
        children: [
            {
                path: '/shop/edit',
                name: 'ShopListEdit',
                component: () => import(/*webpackChunkName: "ShopListEdit"*/ '@/views/shop/list/edit'),
                meta: {
                    title: '店铺装修'
                }
            }
        ]
    },
    // 活动页装修
    {
        path: '/activity',
        name: 'Activity',
        redirect: '/activity/list',
        component: Layout,
        meta: {
            title: '活动页装修'
        },
        children: [
            {
                path: '/activity/list',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/activity/list',
                        name: 'ActivityList',
                        component: () => import(/*webpackChunkName: "ActivityList"*/ '@/views/activity/index'),
                        meta: {
                            title: '活动页列表'
                        }
                    }
                    // {
                    //     path: '/activity/edit',
                    //     name: 'ActivityEdit',
                    //     component: () => import('@/views/activity/edit'),
                    //     meta: {
                    //         title: '活动页添加'
                    //     }
                    // }
                ]
            }
        ]
    },
    // 活动页添加单独的路由 LayoutTop
    {
        path: '/activity',
        name: 'Activitys',
        component: LayoutTop,
        children: [
            {
                path: '/activity/edit',
                name: 'ActivityEdit',
                component: () => import(/*webpackChunkName: "ActivityEdit"*/ '@/views/activity/edit'),
                meta: {
                    title: '活动页添加'
                }
            }
        ]
    },
    // 促销推广
    {
        path: '/promotion',
        name: 'Promotion',
        redirect: '/promotion/full-reduction',
        component: Layout,
        meta: {
            title: '促销推广'
        },
        children: [
            {
                path: '/promotion/full-reduction',
                name: 'PromotionFullReduction',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/promotion/full-reduction',
                        name: 'PromotionFullReductionList',
                        component: () => import(/*webpackChunkName: "PromotionFullReductionList"*/ '@/views/promotion/full-reduction/index'),
                        meta: {
                            title: '满减促销'
                        }
                    },
                    {
                        path: '/promotion/full-reduction/edit',
                        name: 'PromotionFullReductionEdit',
                        component: () => import(/*webpackChunkName: "PromotionFullReductionEdit"*/ '@/views/promotion/full-reduction/Edit'),
                        meta: {
                            title: '满减促销编辑'
                        }
                    },
                    {
                        path: '/promotion/full-reduction/detail',
                        name: 'PromotionFullReductionDetail',
                        component: () => import(/*webpackChunkName: "PromotionFullReductionDetail"*/ '@/views/promotion/full-reduction/Detail'),
                        meta: {
                            title: '满减促销详情'
                        }
                    }
                ]
            },
            {
                path: '/promotion/price-increase',
                name: 'PromotionPriceIncrease',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/promotion/price-increase',
                        name: 'PromotionPriceIncreaseList',
                        component: () => import(/*webpackChunkName: "PromotionPriceIncreaseList"*/ '@/views/promotion/price-increase/index'),
                        meta: {
                            title: '加价购促销'
                        }
                    },
                    {
                        path: '/promotion/price-increase/edit',
                        name: 'PromotionPriceIncreaseEdit',
                        component: () => import(/*webpackChunkName: "PromotionPriceIncreaseEdit"*/ '@/views/promotion/price-increase/Edit'),
                        meta: {
                            title: '加价购促销编辑'
                        }
                    },
                    {
                        path: '/promotion/price-increase/detail',
                        name: 'PromotionPriceIncreaseDetail',
                        component: () => import(/*webpackChunkName: "PromotionPriceIncreaseDetail"*/ '@/views/promotion/price-increase/Detail'),
                        meta: {
                            title: '加价购促销详情'
                        }
                    }
                ]
            },
            {
                path: '/promotion/straight-down',
                name: 'PromotionStraightDown',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/promotion/straight-down',
                        name: 'PromotionStraightDownList',
                        component: () => import(/*webpackChunkName: "PromotionStraightDownList"*/ '@/views/promotion/straight-down/index'),
                        meta: {
                            title: '直降促销'
                        }
                    },
                    {
                        path: '/promotion/straight-down/edit',
                        name: 'PromotionStraightDownEdit',
                        component: () => import(/*webpackChunkName: "PromotionStraightDownEdit"*/ '@/views/promotion/straight-down/Edit'),
                        meta: {
                            title: '直降促销编辑'
                        }
                    },
                    {
                        path: '/promotion/straight-down/detail',
                        name: 'PromotionStraightDownDetail',
                        component: () => import(/*webpackChunkName: "PromotionStraightDownDetail"*/ '@/views/promotion/straight-down/Detail'),
                        meta: {
                            title: '直降促销详情'
                        }
                    }
                ]
            },
            {
                path: '/promotion/group-work',
                name: 'PromotionGroupWork',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/promotion/group-work',
                        name: 'PromotionGroupWorkList',
                        component: () => import(/*webpackChunkName: "PromotionGroupWorkList"*/ '@/views/promotion/group-work/index'),
                        meta: {
                            title: '拼团促销'
                        }
                    },
                    {
                        path: '/promotion/group-work/edit',
                        name: 'PromotionGroupWorkEdit',
                        component: () => import(/*webpackChunkName: "PromotionGroupWorkEdit"*/ '@/views/promotion/group-work/Edit'),
                        meta: {
                            title: '拼团促销编辑'
                        }
                    },
                    {
                        path: '/promotion/group-work/detail',
                        name: 'PromotionGroupWorkDetail',
                        component: () => import(/*webpackChunkName: "PromotionGroupWorkDetail"*/ '@/views/promotion/group-work/Detail'),
                        meta: {
                            title: '拼团促销详情'
                        }
                    }
                ]
            }
        ]
    },
    // 订单中心
    {
        path: '/order',
        name: 'Order',
        redirect: '/order/picking',
        component: Layout,
        meta: {
            title: '订单中心'
        },
        children: [
            {
                path: '/order/picking',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/order/picking',
                        name: 'OrderPicking',
                        component: () => import(/*webpackChunkName: "OrderPicking"*/ '@/views/order/picking/index'),
                        meta: {
                            title: '拣货管家'
                        }
                    },
                    {
                        path: '/order/list-abnormity',
                        name: 'OrderListAbnormity',
                        component: () => import(/*webpackChunkName: "OrderListComplete"*/ '@/views/order/list-abnormity'),
                        meta: {
                            title: '异常订单'
                        }
                    },
                    {
                        path: '/order/list-unsub',
                        name: 'OrderListUnsub',
                        component: () => import(/*webpackChunkName: "OrderListUnsub"*/ '@/views/order/list-unsub'),
                        meta: {
                            title: '退货订单'
                        }
                    },
                    {
                        path: '/order/list-refund',
                        name: 'OrderListRefund',
                        component: () => import(/*webpackChunkName: "OrderListRefund"*/ '@/views/order/list-refund'),
                        meta: {
                            title: '退款订单'
                        }
                    },
                    {
                        path: '/order/list-replenishment',
                        name: 'OrderListReplenishment',
                        component: () => import(/*webpackChunkName: "OrderListReplenishment"*/ '@/views/order/list-replenishment'),
                        meta: {
                            title: '补货订单'
                        }
                    },
                    {
                        path: '/order/list-exchange',
                        name: 'OrderListExchange',
                        component: () => import(/*webpackChunkName: "OrderListExchange"*/ '@/views/order/list-exchange'),
                        meta: {
                            title: '换货订单'
                        }
                    },
                    {
                        path: '/order/list-rejection',
                        name: 'OrderListRejection',
                        component: () => import(/*webpackChunkName: "OrderListRejection"*/ '@/views/order/list-rejection'),
                        meta: {
                            title: '拒收订单'
                        }
                    },
                    {
                        path: '/order/list-resolve',
                        name: 'OrderListResolve',
                        component: () => import(/*webpackChunkName: "OrderListResolve"*/ '@/views/order/list-resolve'),
                        meta: {
                            title: '妥投订单'
                        }
                    },
                    {
                        path: '/order/list-complete',
                        name: 'OrderListComplete',
                        component: () => import(/*webpackChunkName: "OrderListComplete"*/ '@/views/order/list-complete'),
                        meta: {
                            title: '已完成订单'
                        }
                    },
                    {
                        path: '/order/detail',
                        name: 'OrderDetail',
                        component: () => import(/*webpackChunkName: "OrderDetail"*/ '@/views/order/detail/index'),
                        meta: {
                            title: '订单详情'
                        }
                    },
                    {
                        path: '/order/list-search',
                        name: 'OrderListSearch',
                        component: () => import(/*webpackChunkName: "OrderListSearch"*/ '@/views/order/list/index'),
                        meta: {
                            title: '订单查询'
                        }
                    }
                ]
            }
        ]
    },
    // 评价管理
    {
        path: '/evaluate-management',
        name: 'EvaluateManagement',
        redirect: '/evaluate-management',
        component: Layout,
        meta: {
            title: '评价管理'
        },
        children: [
            {
                path: '/evaluate-management',
                name: 'EvaluateManagementList',
                meta: {
                    title: '评价管理列表'
                },
                component: () => import(/*webpackChunkName: "EvaluateManagementList"*/ '@/views/evaluate-management/index')
            }
        ]
    },
    // 优惠券管理
    {
        path: '/coupon',
        name: 'Coupon',
        redirect: '/coupon/index',
        component: Layout,
        meta: {
            title: '优惠券'
        },
        children: [
            {
                path: '/coupon/index',
                name: 'CouponManagement',
                component: () => import(/*webpackChunkName: "CouponManagement"*/ '@/views/coupon/index'),
                meta: {
                    title: '优惠券管理'
                },
                children: null
            },
            {
                path: '/coupon/edit',
                name: 'CouponEdit',
                component: () => import(/*webpackChunkName: "CouponEdit"*/ '@/views/coupon/edit'),
                meta: {
                    title: '优惠券编辑'
                },
                children: null
            },
            {
                path: '/coupon/detail',
                name: 'CouponDetail',
                component: () => import(/*webpackChunkName: "CouponDetail"*/ '@/views/coupon/detail'),
                meta: {
                    title: '优惠券详情'
                },
                children: null
            },
            {
                path: '/coupon/dispatch',
                name: 'DispatchCoupon',
                component: () => import(/*webpackChunkName: "DispatchCoupon"*/ '@/views/coupon/dispatch'),
                meta: {
                    title: '发放优惠券'
                },
                children: null
            },
            {
                path: '/coupon/record',
                name: 'CouponList',
                component: () => import(/*webpackChunkName: "CouponList"*/ '@/views/coupon/record'),
                meta: {
                    title: '发放优惠券记录'
                },
                children: null
            }
        ]
    },
    // 客户运营
    {
        path: '/customer',
        name: 'CustomerOperation',
        redirect: '/customer/remoney-service',
        component: Layout,
        meta: {
            title: '客户运营'
        },
        children: [
            {
                path: '/customer/remoney-service',
                name: 'ReturnMoneyService',
                component: () => import(/*webpackChunkName: "ReturnMoneyService"*/ '@/views/customer/remoney-service'),
                meta: {
                    title: '下单返币'
                },
                children: null
            },
            {
                path: '/customer/promotion-service',
                name: 'PromotionService',
                component: () => import('@/components/EmptyTemplate'),
                meta: {
                    title: '叮叮车'
                },
                children: [
                    {
                        path: '/customer/promotion-service',
                        name: 'PromotionServiceList',
                        component: () => import(/*webpackChunkName: "PromotionServiceList"*/ '@/views/customer/promotion-service'),
                        meta: {
                            title: '叮叮车列表'
                        },
                        children: null
                    },
                    {
                        path: '/customer/promotion-service/detail',
                        name: 'PromotionServiceDetail',
                        component: () => import(/*webpackChunkName: "PromotionServiceDetail"*/ '@/views/customer/promotion-service-detail'),
                        meta: {
                            title: '叮叮车详情'
                        },
                        children: null
                    }
                ]
            },
            {
                path: '/customer/member-discount',
                name: 'MemberDiscount',
                component: () => import(/*webpackChunkName: "MemberDiscount"*/ '@/views/customer/member-discount'),
                meta: {
                    title: '会员折扣'
                },
                children: null
            }
        ]
    },
    // 客服系统
    {
        path: '/customer-service',
        name: 'CustomerService',
        redirect: '/customer-service/group-management',
        component: Layout,
        meta: {
            title: '客服系统'
        },
        children: [
            {
                path: '/customer-servic/to-kefu',
                name: 'CustomerServiceLogin',
                component: () => import(/*webpackChunkName: "CustomerServiceLogin"*/ '@/views/customer-service/to-kefu'),
                meta: {
                    title: '在线客服登录入口'
                },
                children: null
            },
            {
                path: '/customer-service/group-management',
                name: 'CustomerServiceManagement',
                component: () => import(/*webpackChunkName: "CustomerServiceManagement"*/ '@/views/customer-service/group-management'),
                meta: {
                    title: '商家客服组'
                },
                children: null
            },
            {
                path: '/customer-service/bind',
                name: 'CustomerServiceBind',
                component: () => import(/*webpackChunkName: "CustomerServiceBind"*/ '@/views/customer-service/bind'),
                meta: {
                    title: '店铺绑定客服组'
                },
                children: null
            }
        ]
    },
    // 结算管理
    {
        path: '/final',
        name: 'FinalManagement',
        redirect: '/final/final-statement',
        component: Layout,
        meta: {
            title: '结算管理'
        },
        children: [
            // {
            //     path: '/final/goods-detail',
            //     name: 'FinalGoodsDetail',
            //     component: () => import(/*webpackChunkName: "FinalGoodsDetail"*/ '@/views/final/goods-detail'),
            //     meta: { title: '商品明细' },
            //     children: null
            // },
            {
                path: '/final/final-statement',
                name: 'FinalStatement',
                component: () => import('@/components/EmptyTemplate'),
                meta: {
                    title: '结算单管理'
                },
                children: [
                    {
                        path: '/final/final-statement',
                        name: 'FinalStatementList',
                        component: () => import(/*webpackChunkName: "FinalStatement"*/ '@/views/final/final-statement'),
                        meta: {
                            title: '结算单列表'
                        },
                        children: null
                    },
                    {
                        path: '/final/goods-detail',
                        name: 'FinalGoodsDetail',
                        component: () => import(/*webpackChunkName: "FinalGoodsDetail"*/ '@/views/final/goods-detail'),
                        meta: {
                            title: '商品明细'
                        },
                        children: null
                    }
                ]
            },
            {
                path: '/final/new-final-statement',
                name: 'NewFinalStatement',
                component: () => import(/*webpackChunkName: "BalanceManagement"*/ '@/views/final/new-final-statement'),
                meta: {
                    title: '新结算单管理'
                },
                children: null
            },
            {
                path: '/final/payment-order',
                name: 'PaymentOrder',
                component: () => import(/*webpackChunkName: "BalanceManagement"*/ '@/views/final/payment-order'),
                meta: {
                    title: '付款单管理'
                },
                children: null
            },
            {
                path: '/final/invoice',
                name: 'BalanceManagement',
                component: () => import(/*webpackChunkName: "BalanceManagement"*/ '@/views/final/invoice'),
                meta: {
                    title: '用户申请开票管理'
                },
                children: null
            },
            {
                path: '/final/rebate',
                name: 'RebateManagement',
                component: () => import(/*webpackChunkName: "RebateManagement"*/ '@/views/final/rebate'),
                meta: {
                    title: '返佣明细管理'
                },
                children: null
            },
            {
                path: '/final/app',
                name: 'ApplicationManagement',
                component: () => import(/*webpackChunkName: "ApplicationManagement"*/ '@/views/final/app'),
                meta: {
                    title: '应用市场结算管理'
                },
                children: null
            },
            {
                path: '/final/download',
                name: 'DownloadList',
                component: () => import(/*webpackChunkName: "DownloadList"*/ '@/views/final/downloadList'),
                meta: {
                    title: '导出管理'
                },
                children: null
            }
        ]
    },
    // 公司鉴权管理
    {
        path: '/company-auth',
        name: 'CompanyAuth',
        redirect: '/company-auth',
        component: Layout,
        meta: {
            title: '公司鉴权'
        },
        children: [
            {
                path: '/company-auth',
                name: 'CompanyAuthManagement',
                component: () => import('@/components/EmptyTemplate'),
                meta: {
                    title: '公司鉴权管理'
                },
                children: [
                    {
                        path: '/company-auth',
                        name: 'CompanyAuthManagementList',
                        component: () => import(/*webpackChunkName: "CompanyAuthManagementList"*/ '@/views/company-auth'),
                        meta: {
                            title: '公司鉴权列表'
                        },
                        children: null
                    },
                    {
                        path: '/company-auth/edit',
                        name: 'CompanyAuthManagementEdit',
                        component: () => import(/*webpackChunkName: "CompanyAuthManagementEdit"*/ '@/views/company-auth/Edit'),
                        meta: {
                            title: '绑卡'
                        },
                        children: null
                    }
                ]
            }
        ]
    },
    //跨境管理
    { path: '/overseas-services',
        name: 'overseas-services',
        redirect: '/overseas-services',
        component: Layout,
        meta: {
            title: '跨境管理'
        },
        children: [
            {
                path: '/overseas-services/product-notice',
                component: () => import('@/components/EmptyTemplate'),
                children: [
                    {
                        path: '/overseas-services/product-notice',
                        name: 'ProductNoticeView',
                        component: () => import(/*webpackChunkName: "FenceView"*/ '@/views/overseas-services/product-notice/index'),
                        meta: {
                            title: '商品须知'
                        }
                    },
                ]
            }
        ]
    },
    // 服务市场
    {
        path: '/service-marker',
        name: 'ServiceMarket',
        redirect: '/service-marker/service-list',
        component: Layout,
        meta: {
            title: '服务市场'
        },
        children: [
            {
                path: '/service-marker/service-list',
                name: 'ServiceList',
                component: () => import(/*webpackChunkName: "ServiceList"*/ '@/views/service-marker/service/index'),
                meta: {
                    title: '服务列表'
                },
                children: null
            },
            {
                path: '/service-marker/service-list/detail',
                name: 'ServiceDetail',
                component: () => import(/*webpackChunkName: "ServiceDetail"*/ '@/views/service-marker/service/detail'),
                meta: {
                    title: '服务详情'
                },
                children: null
            },
            {
                path: '/service-marker/service-list/progress',
                name: 'ServiceProgress',
                component: () => import(/*webpackChunkName: "ServiceProgress"*/ '@/views/service-marker/service/progress'),
                meta: {
                    title: '服务订单'
                },
                children: null
            },
            {
                path: '/service-marker/order',
                name: 'MyOrder',
                component: () => import(/*webpackChunkName: "MyOrder"*/ '@/views/service-marker/order'),
                meta: {
                    title: '我的订单'
                },
                children: null
            }
        ]
    },
    // 权限管理
    {
        path: '/auth-management',
        name: 'AuthManagement',
        redirect: '/auth-management/user-management',
        component: Layout,
        meta: {
            title: '权限管理'
        },
        children: [
            {
                path: '/auth-management/user-management',
                name: 'UserManagement',
                component: () => import(/*webpackChunkName: "UserManagement"*/ '@/views/auth-management/user-management'),
                meta: {
                    title: '用户管理'
                },
                children: null
            },
            {
                path: '/auth-management/role-management',
                name: 'RoleManagement',
                component: () => import(/*webpackChunkName: "RoleManagement"*/ '@/views/auth-management/role-management'),
                meta: {
                    title: '角色管理'
                },
                children: null
            }
        ]
    }
]
export default routes
